module.exports = __webpack_public_path__ + "static/media/bill.0cb56b64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bill.svg
// module id = 1232
// module chunks = 0